
import React from "react";
import { Link } from "react-router-dom";
import { defaultRegionMap } from "./RegionMap";

// Créer une carte inversée pour obtenir les départements par région
const getDepartmentsByRegion = () => {
  const regions: Record<string, {code: string, name: string}[]> = {};
  
  // Mappage des codes de départements aux noms
  const departmentNames: Record<string, string> = {
    '12': 'Aveyron',
    '81': 'Tarn',
    '15': 'Cantal',
    '95': 'Val-d\'Oise',
    '46': 'Lot',
    '11': 'Aude',
    '31': 'Haute-Garonne',
    '34': 'Hérault',
    '48': 'Lozère',
    '30': 'Gard',
    '82': 'Tarn-et-Garonne',
    '93': 'Seine-Saint-Denis',
    '92': 'Hauts-de-Seine',
    '75': 'Paris',
    '78': 'Yvelines',
    '43': 'Haute-Loire',
    '63': 'Puy-de-Dôme'
  };
  
  // Regrouper les départements par région
  Object.entries(defaultRegionMap).forEach(([deptCode, region]) => {
    if (!regions[region]) {
      regions[region] = [];
    }
    regions[region].push({
      code: deptCode,
      name: departmentNames[deptCode] || deptCode
    });
  });
  
  return regions;
};

const DepartmentList: React.FC = () => {
  const departmentsByRegion = getDepartmentsByRegion();
  
  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-heading font-bold mb-6 text-fabre-green text-center">
          Nos services par département
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {Object.entries(departmentsByRegion).map(([region, departments]) => (
            <div key={region} className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-fabre-darkgreen mb-4">{region}</h3>
              <ul className="space-y-2">
                {departments.sort((a, b) => a.name.localeCompare(b.name)).map((dept) => (
                  <li key={dept.code} className="flex items-center">
                    <Link 
                      to={`/sites?dept=${dept.code}`}
                      className="text-gray-700 hover:text-fabre-green flex items-center"
                    >
                      <span className="w-6 h-6 bg-fabre-lightgreen text-fabre-green rounded-full text-xs flex items-center justify-center mr-2">
                        {dept.code}
                      </span>
                      {dept.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-gray-700">
            Le Groupe Fabre Environnement propose ses services de collecte, recyclage et valorisation des déchets dans plusieurs régions de France. 
            Notre expertise s'étend à travers l'Occitanie, l'Auvergne-Rhône-Alpes et l'Île-de-France, où nous disposons de centres spécialisés 
            pour répondre à tous vos besoins en matière de gestion des déchets.
          </p>
          <p className="text-gray-700 mt-4">
            Que vous soyez un professionnel, une collectivité ou un particulier, nous vous proposons des solutions adaptées à vos besoins spécifiques 
            dans chacun de nos départements d'intervention.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DepartmentList;
